import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import NodeRunStatus from './NodeRunStatus.vue';
import ProgressBarFooter from './ProgressBarFooter.vue';
import ProgressBarActions from './ProgressBarActions.vue';
import { NodeRunState } from '@ply-io/runner';

type NodeRunId = string;

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    nodeRuns: null,
    startMinimized: { type: Boolean, default: true },
    percentCompleted: null,
    text: null,
    allowMinimize: { type: Boolean, default: false },
    allowRestart: { type: Boolean, default: false },
    allowStop: { type: Boolean, default: false },
    disableRestart: { type: Boolean, default: false },
    disableStop: { type: Boolean, default: false },
    showPercentage: { type: Boolean }
  },
  emits: ["close", "stop", "restart"],
  setup(__props: any, { expose }: { emit: ({ (e: 'close'): void; (e: 'stop'): void; (e: 'restart'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { nodeRuns: NodeRunState[], startMinimized: boolean, percentCompleted: string, text: string, allowMinimize: boolean, allowRestart: boolean, allowStop: boolean, disableRestart: boolean, disableStop: boolean, showPercentage: boolean }



const isMinimized = ref(props.startMinimized);
const nodeRunStatuses = ref<InstanceType<typeof NodeRunStatus>[]>([]);
const actionsList = ref<HTMLDivElement | null>(null);
const isHTMLDivElement = (el: Element): el is HTMLDivElement => el instanceof HTMLDivElement;
const scrollToNodeRun = (nodeRunId: NodeRunId) => {
	const nodeRunStatus = nodeRunStatuses.value.find((nodeRunStatus) => nodeRunStatus.nodeRun.id === nodeRunId);
	if (nodeRunStatus) {
		const div = nodeRunStatus.$el;
		if (!isHTMLDivElement(div)) {
			console.warn('[ProgressBar] - Weird element for nodeRunStatus');
			return;
		}
		const scrollTop = div.offsetTop;
		if (scrollTop && actionsList.value) {
			actionsList.value.scrollTo({ top: scrollTop, behavior: 'smooth' });
		}
	}
};
expose({
	scrollToNodeRun,
});

return { __sfc: true,props, isMinimized, nodeRunStatuses, actionsList, isHTMLDivElement, scrollToNodeRun, NodeRunStatus, ProgressBarFooter, ProgressBarActions }
}

})